module.exports = __webpack_public_path__ + "img/shujiao.6a67aacb.png";